/** Предустановленные причины отмены (значение в БД = текст, кроме «Не указана» = пусто). Тексты — общий контракт с метрикой отмен на сервере. */
import { CANCEL_REASON_PRESET_NOTES } from '@sessionCancel/cancelReasonPresets';

const PRESET_ID_TO_NOTE: Record<string, string> = CANCEL_REASON_PRESET_NOTES;

const NOTE_TO_PRESET_ID = Object.fromEntries(
  Object.entries(PRESET_ID_TO_NOTE).map(([id, note]) => [note, id])
) as Record<string, string>;

export const CANCEL_REASON_SELECT_OPTIONS: { value: string; label: string }[] = [
  { value: 'none', label: 'Не указана' },
  { value: 'extra', label: 'Лишняя сессия' },
  { value: 'reader_request', label: 'Отменена по просьбе чтеца' },
  { value: 'studio_initiative', label: 'Отменена по инициативе студии' },
  { value: 'no_show', label: 'Неявка чтеца' },
  { value: 'booking_error', label: 'Сессия забронирована по ошибке' },
  { value: 'other', label: 'Другая причина' },
];

export function inferCancelReasonPreset(note: string): { presetId: string; custom: string } {
  const t = note.trim();
  if (!t) return { presetId: 'none', custom: '' };
  const id = NOTE_TO_PRESET_ID[t];
  if (id && id !== 'none' && id !== 'other') {
    return { presetId: id, custom: '' };
  }
  return { presetId: 'other', custom: note };
}

export function noteForCancelPreset(presetId: string, customTrimmed: string): string {
  if (presetId === 'none') return '';
  if (presetId === 'other') return customTrimmed;
  return PRESET_ID_TO_NOTE[presetId] ?? '';
}
